var exports = {
  "Qf": "CommitRow__w1guph",
  "BD": "Summary__3S29m4",
  "In": "Icon__vBpWxI",
  "hE": "Title__YUzlpe",
  "En": "Actions__f-591X",
  "$R": "Sha__Im-prd",
};

module.exports = exports;
